import './style.scss';
import { useState } from 'react';
import { PromoCode as Promo } from 'src/models/general';
import { Loader } from '@components/common/Loader';
import { PromoCodeCharge } from './PromoCodeCharge/PromoCodeCharge';
import { PromoCodeInsertion } from './PromoCodeInsertion/PromoCodeInsertion';

interface PromoCodeProps {
  onPromoCodeDelete: (value?: string) => void;
  onPromoCodeApply: (value: string, cb: () => void) => void;
  promoCode: Promo | null;
  isLoading: boolean;
  promoError: string | null;
  hideDiscountAmount?: boolean;
}

export const PromoCode = (props: PromoCodeProps) => {
  const [isOpened, setIsOpened] = useState(false);

  const handlePromoCodeAdd = async () => {
    setIsOpened(true);
  };

  const handlePromoCodeApply = (value: string) => {
    props.onPromoCodeApply(value, () => setIsOpened(false));
  };

  if (props.isLoading) {
    return <Loader />;
  }

  return (
    <div data-testid="promo-code">
      { !isOpened
        ? (
          <PromoCodeCharge
            hideDiscountAmount={props.hideDiscountAmount}
            promoCode={props.promoCode}
            onPromoCodeAdd={handlePromoCodeAdd}
            onPromoCodeDelete={props.onPromoCodeDelete}
          />
        )
        : (
          <PromoCodeInsertion
            promoError={props.promoError}
            onPromoCodeApply={handlePromoCodeApply}
          />
        )}
    </div>
  );
};
